const Builder = require('../BuilderBase');

module.exports = class ToLowerCase extends Builder {
    constructor(properties) {
        super('transform_ToLowerCase', '', properties);
    }
};
